/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TrackingContext } from '@vrbo/react-event-tracking';
import SubmitButton from '../../Button/SubmitButton';
import CompetitorLink from './CompetitorLink';
import { VrboCtx } from '../../../contexts/vrbo';
import { ESTIMATE_PAGE } from '../../PageFlow/PageList';

const pageName = ESTIMATE_PAGE;

function EstimateCta(props) {
    const {
        triggerPropertyCreation,
        loading
    } = useContext(VrboCtx);

    const {
        estimateButtonLabel
    } = props;

    const { trigger } = useContext(TrackingContext);

    const handleClick = () => {
        trigger('genericClick', {
            category: 'navigation',
            action: 'EstimateResults: nextButton'
        });
        triggerPropertyCreation(pageName);
    };

    const { competitorLink } = props;

    return (
        <>
            <CompetitorLink
                {
                    ...{
                        ...competitorLink
                    }
                }
            />
            <SubmitButton data-wdio="next-button" animated={loading} label={estimateButtonLabel} disabled={loading} onClick={handleClick} />
        </>
    );
}

EstimateCta.propTypes = {
    estimateButtonLabel: PropTypes.string.isRequired,
    competitorLink: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        fieldLabel: PropTypes.string,
        display: PropTypes.bool.isRequired
    }).isRequired,
    pageFlow: PropTypes.shape({
        next: PropTypes.func
    }).isRequired
};

export default EstimateCta;
